interface JwtPayload {
  [key: string]: unknown
  SecurityContactCultureId?: string
}

export function decodeJwtToken(token: string): JwtPayload | null {
  try {
    const parts = token.split(".")
    if (parts.length !== 3) {
      return null
    }
    const payload = parts[1]
    const padded = payload + "=".repeat((4 - (payload.length % 4)) % 4)
    const decoded = atob(padded.replace(/-/g, "+").replace(/_/g, "/"))
    return JSON.parse(decoded)
  } catch {
    return null
  }
}

// SecurityContactCultureId: '48' = English, '88' = French. Defaults to 'en'.
export function getLanguageFromToken(token: string): "en" | "fr" {
  const payload = decodeJwtToken(token)
  const cultureId = payload?.SecurityContactCultureId
  if (cultureId === "88") return "fr"
  return "en"
}
